import React from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

const Interaction = ({icon, value}) => (
  <span className="interaction">
    <span className={icon} />
    {value}
  </span>
)

const Interactions = ({likesCount, viewsCount, showViews, showLikes}) => (
  <div className="interactions-container">
    {showLikes && (
      <Interaction
        icon={'icon-like-full'}
        value={likesCount}
        title={"likes"} />
    )}
    {showViews && (
      <Interaction
        icon={'icon-views'}
        value={viewsCount}
        title={"views"} />
    )}
  </div>
)


Interactions.propTypes = {
  likesCount: PropTypes.number.isRequired,
  // viewsCount: PropTypes.number.isRequired,
  showViews: PropTypes.bool,
  showLikes: PropTypes.bool
}

export default Interactions
